module.exports = __webpack_public_path__ + "static/Costco_pin-98edb886d4ebe281dfef7365e5632e19.png";